module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"payTitulos":["Forma parte de nuestra red de socios. Juntos llegamos más lejos. "]},"es":{"payTitulos":["Forma parte de nuestra red de socios. Juntos llegamos más lejos."]}}')
  delete Component.options._Ctor
}
